export default "__VITE_ASSET__BcaQzT9$__"